import { CONFIG_SERVICE_KEYS } from '@web-platform/shared-universal-constants-config';
import { translate } from '@web-platform/shared-universal-translations';
import { getConfigServiceValue } from '@web-platform/shared-universal-utils-frontend/src/config';

export const getParallelSearchOptionLabel = () => {
  const configLabel = getConfigServiceValue(CONFIG_SERVICE_KEYS.EXPERIMENT.PARALLEL_SEARCH_LABEL);

  switch (configLabel) {
    case 'searchControls_checkbox_exploreHotels':
      return translate('searchControls_checkbox_exploreHotels');
    case 'searchControls_checkbox_exploreHotelsForYourDates':
      return translate('searchControls_checkbox_exploreHotelsForYourDates');
    case 'searchControls_checkbox_findHotels':
      return translate('searchControls_checkbox_findHotels');
    case 'searchControls_checkbox_findHotelsForYourDates':
      return translate('searchControls_checkbox_findHotelsForYourDates');
    case 'ktxt_searchControls_parallelSearch_stays':
      return translate('ktxt_searchControls_parallelSearch_stays');
    default:
      return translate('ktxt_searchControls_parallelSearch_stays');
  }
};

export const getPackagesParallelSearchOptionLabel = (): string => {
  const configLabel = getConfigServiceValue(
    CONFIG_SERVICE_KEYS.EXPERIMENT.PACKAGES_PARALLEL_SEARCH_LABEL,
  );

  switch (configLabel) {
    case 'ktxt_searchControls_parallelSearch_comparePackagesToo':
      return translate('ktxt_searchControls_parallelSearch_comparePackagesToo');
    case 'ktxt_searchControls_parallelSearch_openPackagesSearch':
      return translate('ktxt_searchControls_parallelSearch_openPackagesSearch');
    case 'ktxt_searchControls_parallelSearch_findPackageHolidaysForYourDates':
      return translate('ktxt_searchControls_parallelSearch_findPackageHolidaysForYourDates');
    case 'ktxt_searchControls_parallelSearch_comparePackageHolidayPricesToo':
      return translate('ktxt_searchControls_parallelSearch_comparePackageHolidayPricesToo');
    default:
      return translate('ktxt_searchControls_parallelSearch_comparePackagesToo');
  }
};
